'use strict';
const helper = require('../util/helpers');

module.exports = function () {
    if (!window.DY || !window.DY.API) {
        console.error('window.DY.API not found');
        return;
    }

    $('.subscribe-email').click((e) => {
        const email = $(e.target).closest('form').find('[name$="mailSignUp"]').val();
        helper.triggerNewsletterSignup(email);
        helper.triggerIdentifyEvent(email);
    });

    // send data to DY
    document.body.addEventListener('dynamicYieldEvent', (e) => {
        window.DY.API('event', e.detail);
    });

    // send identify data to DY for additional tracking
    document.body.addEventListener('dynamicYieldIdentify', (e) => {
        window.DY.API('identify', e.detail);
    });
};
